// extracted by extract-css-chunks-webpack-plugin
module.exports = {"share_box":"share_box-1pPW4llF"};